import { Component, forwardRef, ChangeDetectionStrategy, Inject, Injector, ChangeDetectorRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbpValidationDisplayConstant, AbpValidationDisplayModule } from '@colibrium/abp-validation-display';
import { SelectListControlBase, ControlBase } from '@colibrium/abp-form-control-base';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@colibrium/abp-label';
import * as ɵngcc3 from '@colibrium/abp-validation-display';

function AbpRadioButtonListComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "input", 6, 7);
    ɵngcc0.ɵɵlistener("change", function AbpRadioButtonListComponent_ng_container_0_ng_container_3_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const entry_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onSelectionChange(entry_r2); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.inputControlCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate3("id", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "_", i_r3, "");
    ɵngcc0.ɵɵpropertyInterpolate2("name", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate("value", entry_r2.value);
    ɵngcc0.ɵɵproperty("disabled", entry_r2.isDisabled)("checked", entry_r2.isSelected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate3("for", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "_", i_r3, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", entry_r2.displayText, " ");
} }
function AbpRadioButtonListComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵtemplate(3, AbpRadioButtonListComponent_ng_container_0_ng_container_3_Template, 6, 13, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(4, "abp-validation-display", 4);
    ɵngcc0.ɵɵlistener("isControlValid", function AbpRadioButtonListComponent_ng_container_0_Template_abp_validation_display_isControlValid_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setClassForControlValidity($event); });
    ɵngcc0.ɵɵpipe(5, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_radiolist_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.displayLabelField);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.field.options);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("control", ɵngcc0.ɵɵpipeBind1(5, 7, ctx_r0.control))("isSubmitted", ctx_r0.isFormSubmitted)("validationMap", ctx_r0.field.validationMap);
} }
function AbpRadioListInlineComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 5);
    ɵngcc0.ɵɵelementStart(2, "input", 6, 7);
    ɵngcc0.ɵɵlistener("change", function AbpRadioListInlineComponent_ng_container_0_ng_container_4_Template_input_change_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const entry_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.onSelectionChange(entry_r2); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "label", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const entry_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.inputControlCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate3("id", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "_", i_r3, "");
    ɵngcc0.ɵɵpropertyInterpolate2("name", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate("value", entry_r2.value);
    ɵngcc0.ɵɵproperty("disabled", entry_r2.isDisabled)("checked", entry_r2.isSelected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate3("for", "rdb_abp_radiolist_", ctx_r1.id, "_", ctx_r1.field.fieldCode, "_", i_r3, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", entry_r2.displayText, " ");
} }
function AbpRadioListInlineComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtemplate(4, AbpRadioListInlineComponent_ng_container_0_ng_container_4_Template, 6, 13, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "abp-validation-display", 4);
    ɵngcc0.ɵɵlistener("isControlValid", function AbpRadioListInlineComponent_ng_container_0_Template_abp_validation_display_isControlValid_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setClassForControlValidity($event); });
    ɵngcc0.ɵɵpipe(6, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_radiolist_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.displayLabelField);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.field.options);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("control", ɵngcc0.ɵɵpipeBind1(6, 7, ctx_r0.control))("isSubmitted", ctx_r0.isFormSubmitted)("validationMap", ctx_r0.field.validationMap);
} }
const _c0 = ".abp-radio[_ngcontent-%COMP%]{position:relative;vertical-align:baseline;margin:0;padding:0 0 5px}.abp-radio[_ngcontent-%COMP%]   abp-label[_ngcontent-%COMP%], .abp-radio[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{cursor:pointer;line-height:1.5;vertical-align:middle;display:inline-block;padding:0 0 1%;margin:0 .5rem .5rem}.abp-radio[_ngcontent-%COMP%]   .option-btn[_ngcontent-%COMP%]{width:20px;height:20px;display:inline-block;outline-offset:-1px!important}.error[_ngcontent-%COMP%]{outline:#dc3545 solid 2px}.valid[_ngcontent-%COMP%]{outline:#28a745 solid 2px}.abp-radio[_ngcontent-%COMP%]   abp-control-label[_ngcontent-%COMP%]{vertical-align:super;margin-right:.5rem}.abp-switch-button[_ngcontent-%COMP%]{box-sizing:border-box}.abp-switch-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{position:relative;display:inline-block;width:75px;height:40px;margin-right:10px;border-radius:20px}.abp-switch-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{transform:scale(1.2)}.abp-switch-button[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}.abp-switch-button[_ngcontent-%COMP%]   .active[_ngcontent-%COMP%]{background-color:#87cefa}.slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]{background-color:#2196f3}input[_ngcontent-%COMP%]:focus + .slider[_ngcontent-%COMP%]{box-shadow:0 0 1px #2196f3}input[_ngcontent-%COMP%]:checked + .slider[_ngcontent-%COMP%]:before{transform:translateX(26px)}.slider.round[_ngcontent-%COMP%]{border-radius:34px}.slider.round[_ngcontent-%COMP%]:before{border-radius:50%}";
const _c1 = function (a0, a1) { return [a0, a1]; };
function AbpSwitchComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "button", 4);
    ɵngcc0.ɵɵlistener("click", function AbpSwitchComponent_ng_container_0_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onBtnClick(true); });
    ɵngcc0.ɵɵelement(5, "input", 5);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 6);
    ɵngcc0.ɵɵlistener("click", function AbpSwitchComponent_ng_container_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onBtnClick(false); });
    ɵngcc0.ɵɵelement(8, "input", 7);
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "abp-validation-display", 8);
    ɵngcc0.ɵɵlistener("isControlValid", function AbpSwitchComponent_ng_container_0_Template_abp_validation_display_isControlValid_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setClassForControlValidity($event); });
    ɵngcc0.ɵɵpipe(11, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_radiolist_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.displayLabelField);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "btn_abp_switch_on_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(26, _c1, ctx_r0.inputControlCss, ctx_r0.value === true ? "active" : ""))("disabled", ctx_r0.field.isDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("name", "rdb_abp_switch_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate2("id", "rdb_abp_switch_on_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.field.onSwitchDisplayText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "btn_abp_switch_off_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(29, _c1, ctx_r0.inputControlCss, ctx_r0.value === false ? "active" : ""))("disabled", ctx_r0.field.isDisabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("name", "rdb_abp_switch_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵpropertyInterpolate2("id", "rdb_abp_switch_off_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.field.offSwitchDisplayText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("control", ɵngcc0.ɵɵpipeBind1(11, 24, ctx_r0.control))("isSubmitted", ctx_r0.isFormSubmitted)("validationMap", ctx_r0.field.validationMap);
} }
export { AbpRadioButtonFieldModel, AbpSwitchFieldModel } from '@colibrium/abp-form-control-base';
import { AbpBaseConstant } from '@colibrium/abp-base';
import { CommonModule } from '@angular/common';
import { AbpLabelConstant, AbpLabelModule } from '@colibrium/abp-label';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpRadioConstant extends AbpBaseConstant {
}
AbpRadioConstant.abp_radio = 'abp-radio';
AbpRadioConstant.abp_switch = '';
if (false) {
    /** @type {?} */
    AbpRadioConstant.abp_radio;
    /** @type {?} */
    AbpRadioConstant.abp_switch;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpRadioButtonListComponent extends SelectListControlBase {
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     * @param {?} inj
     * @param {?} detector
     */
    constructor(config, inj, detector) {
        super(inj, config, detector);
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitialization(AbpRadioConstant.abp_radio);
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        this.onNgInputChanges(simpleChanges, AbpRadioConstant.abp_radio);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.onViewInitialization();
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * on selection change
     * @param {?} option
     * @return {?}
     */
    onSelectionChange(option) {
        this.setOptionSelectionState(option.value);
        this.onInputChange(option.value);
    }
}
AbpRadioButtonListComponent.ɵfac = function AbpRadioButtonListComponent_Factory(t) { return new (t || AbpRadioButtonListComponent)(ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbpRadioButtonListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpRadioButtonListComponent, selectors: [["abp-radio-button"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpRadioButtonListComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], [4, "ngFor", "ngForOf"], [3, "control", "isSubmitted", "validationMap", "isControlValid"], [3, "ngClass"], ["type", "radio", 1, "option-btn", 3, "id", "name", "value", "disabled", "checked", "change"], ["inputControlVariable", ""], [3, "for"]], template: function AbpRadioButtonListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpRadioButtonListComponent_ng_container_0_Template, 6, 9, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpFieldDisplayLabelComponent, ɵngcc1.NgForOf, ɵngcc3.AbpValidationDisplayComponent, ɵngcc1.NgClass], pipes: [ɵngcc1.AsyncPipe], styles: [_c0], changeDetection: 0 });
/** @nocollapse */
AbpRadioButtonListComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: Injector },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpRadioButtonListComponent, [{
        type: Component,
        args: [{
                selector: 'abp-radio-button',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_radiolist_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"displayLabelField\"></abp-field-display-label>\r\n\r\n    <ng-container *ngFor=\"let entry of field.options; index as i\">\r\n      <div [ngClass]=\"inputControlCss\">\r\n\r\n        <input type=\"radio\"\r\n               id=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}_{{i}}\"\r\n               name=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}\"\r\n               class=\"option-btn\"\r\n               (change)=\"onSelectionChange(entry)\"\r\n               value={{entry.value}}\r\n               [disabled]=\"entry.isDisabled\"\r\n               [checked]=\"entry.isSelected\"\r\n               #inputControlVariable />\r\n        <label for=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}_{{i}}\">\r\n          {{entry.displayText}}\r\n        </label>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <abp-validation-display [control]=\"control|async\"\r\n                            [isSubmitted]=\"isFormSubmitted\"\r\n                            [validationMap]=\"field.validationMap\"\r\n                            (isControlValid)=\"setClassForControlValidity($event)\"></abp-validation-display>\r\n  </div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpRadioButtonListComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-radio{position:relative;vertical-align:baseline;margin:0;padding:0 0 5px}.abp-radio abp-label,.abp-radio label{cursor:pointer;line-height:1.5;vertical-align:middle;display:inline-block;padding:0 0 1%;margin:0 .5rem .5rem}.abp-radio .option-btn{width:20px;height:20px;display:inline-block;outline-offset:-1px!important}.error{outline:#dc3545 solid 2px}.valid{outline:#28a745 solid 2px}.abp-radio abp-control-label{vertical-align:super;margin-right:.5rem}.abp-switch-button{box-sizing:border-box}.abp-switch-button button{position:relative;display:inline-block;width:75px;height:40px;margin-right:10px;border-radius:20px}.abp-switch-button button:hover{transform:scale(1.2)}.abp-switch-button input{opacity:0;width:0;height:0}.abp-switch-button .active{background-color:#87cefa}.slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#2196f3}input:focus+.slider{box-shadow:0 0 1px #2196f3}input:checked+.slider:before{transform:translateX(26px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpRadioListInlineComponent extends SelectListControlBase {
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     * @param {?} inj
     * @param {?} detector
     */
    constructor(config, inj, detector) {
        super(inj, config, detector);
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitialization(AbpRadioConstant.abp_radio);
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        this.onNgInputChanges(simpleChanges, AbpRadioConstant.abp_radio);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.onViewInitialization();
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * on selection change
     * @param {?} option
     * @return {?}
     */
    onSelectionChange(option) {
        this.setOptionSelectionState(option.value);
        this.onInputChange(option.value);
    }
}
AbpRadioListInlineComponent.ɵfac = function AbpRadioListInlineComponent_Factory(t) { return new (t || AbpRadioListInlineComponent)(ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbpRadioListInlineComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpRadioListInlineComponent, selectors: [["abp-radio-list-inline"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpRadioListInlineComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], [4, "ngFor", "ngForOf"], [3, "control", "isSubmitted", "validationMap", "isControlValid"], [3, "ngClass"], ["type", "radio", 1, "option-btn", 3, "id", "name", "value", "disabled", "checked", "change"], ["inputControlVariable", ""], [3, "for"]], template: function AbpRadioListInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpRadioListInlineComponent_ng_container_0_Template, 7, 9, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpFieldDisplayLabelComponent, ɵngcc1.NgForOf, ɵngcc3.AbpValidationDisplayComponent, ɵngcc1.NgClass], pipes: [ɵngcc1.AsyncPipe], styles: [_c0], changeDetection: 0 });
/** @nocollapse */
AbpRadioListInlineComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: Injector },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpRadioListInlineComponent, [{
        type: Component,
        args: [{
                selector: 'abp-radio-list-inline',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_radiolist_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"displayLabelField\"></abp-field-display-label>\r\n\r\n    <div>\r\n      <ng-container *ngFor=\"let entry of field.options; index as i\">\r\n        <span [ngClass]=\"inputControlCss\">\r\n          <input type=\"radio\"\r\n                 id=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}_{{i}}\"\r\n                 name=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}\"\r\n                 class=\"option-btn\"\r\n                 (change)=\"onSelectionChange(entry)\"\r\n                 value={{entry.value}}\r\n                 [disabled]=\"entry.isDisabled\"\r\n                 [checked]=\"entry.isSelected\"\r\n                 #inputControlVariable />\r\n          <label for=\"rdb_abp_radiolist_{{id}}_{{field.fieldCode}}_{{i}}\">\r\n            {{entry.displayText}}\r\n          </label>\r\n        </span>\r\n      </ng-container>\r\n    </div>\r\n    <abp-validation-display [control]=\"control|async\"\r\n                            [isSubmitted]=\"isFormSubmitted\"\r\n                            [validationMap]=\"field.validationMap\"\r\n                            (isControlValid)=\"setClassForControlValidity($event)\"></abp-validation-display>\r\n  </div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpRadioListInlineComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-radio{position:relative;vertical-align:baseline;margin:0;padding:0 0 5px}.abp-radio abp-label,.abp-radio label{cursor:pointer;line-height:1.5;vertical-align:middle;display:inline-block;padding:0 0 1%;margin:0 .5rem .5rem}.abp-radio .option-btn{width:20px;height:20px;display:inline-block;outline-offset:-1px!important}.error{outline:#dc3545 solid 2px}.valid{outline:#28a745 solid 2px}.abp-radio abp-control-label{vertical-align:super;margin-right:.5rem}.abp-switch-button{box-sizing:border-box}.abp-switch-button button{position:relative;display:inline-block;width:75px;height:40px;margin-right:10px;border-radius:20px}.abp-switch-button button:hover{transform:scale(1.2)}.abp-switch-button input{opacity:0;width:0;height:0}.abp-switch-button .active{background-color:#87cefa}.slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#2196f3}input:focus+.slider{box-shadow:0 0 1px #2196f3}input:checked+.slider:before{transform:translateX(26px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpSwitchComponent extends ControlBase {
    //#region input properties
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     * @param {?} inj
     * @param {?} detector
     */
    constructor(config, inj, detector) {
        super(inj, config, detector);
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitialization(AbpRadioConstant.abp_switch);
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        this.onNgInputChanges(simpleChanges, AbpRadioConstant.abp_switch);
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.onViewInitialization();
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    /**
     * on button click
     * @param {?} val
     * @return {?}
     */
    onBtnClick(val) {
        this.onInputChange(val);
    }
}
AbpSwitchComponent.ɵfac = function AbpSwitchComponent_Factory(t) { return new (t || AbpSwitchComponent)(ɵngcc0.ɵɵdirectiveInject(AbpValidationDisplayConstant.validationDisplayConfigInjectKey), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AbpSwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpSwitchComponent, selectors: [["abp-switch"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpSwitchComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], [1, "abp-switch-button"], ["type", "button", 1, "left", 3, "id", "ngClass", "disabled", "click"], ["type", "radio", "value", "true", 3, "name", "id"], ["type", "button", 3, "id", "ngClass", "disabled", "click"], ["type", "radio", "value", "false", 3, "name", "id"], [3, "control", "isSubmitted", "validationMap", "isControlValid"]], template: function AbpSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpSwitchComponent_ng_container_0_Template, 12, 32, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.AbpFieldDisplayLabelComponent, ɵngcc1.NgClass, ɵngcc3.AbpValidationDisplayComponent], pipes: [ɵngcc1.AsyncPipe], styles: [_c0], changeDetection: 0 });
/** @nocollapse */
AbpSwitchComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey,] }] },
    { type: Injector },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'abp-switch',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_radiolist_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"displayLabelField\"></abp-field-display-label>\r\n    <div class=\"abp-switch-button\">\r\n      <button id=\"btn_abp_switch_on_{{id}}_{{field.fieldCode}}\"\r\n              type=\"button\"\r\n              class=\"left\"\r\n              [ngClass]=\"[inputControlCss, value === true? 'active': '']\"\r\n              (click)=\"onBtnClick(true)\"\r\n              [disabled]=\"field.isDisabled\">\r\n        <input type=\"radio\"\r\n               name=\"rdb_abp_switch_{{id}}_{{field.fieldCode}}\"\r\n               id=\"rdb_abp_switch_on_{{id}}_{{field.fieldCode}}\"\r\n               value=\"true\" />\r\n        {{field.onSwitchDisplayText}}\r\n      </button>\r\n      <button id=\"btn_abp_switch_off_{{id}}_{{field.fieldCode}}\"\r\n              type=\"button\"\r\n              [ngClass]=\"[inputControlCss, value === false? 'active': '']\"\r\n              (click)=\"onBtnClick(false)\"\r\n              [disabled]=\"field.isDisabled\">\r\n        <input type=\"radio\"\r\n               name=\"rdb_abp_switch_{{id}}_{{field.fieldCode}}\"\r\n               id=\"rdb_abp_switch_off_{{id}}_{{field.fieldCode}}\"\r\n               value=\"false\" />\r\n        {{field.offSwitchDisplayText}}\r\n      </button>\r\n    </div>\r\n    <abp-validation-display [control]=\"control|async\"\r\n                            [isSubmitted]=\"isFormSubmitted\"\r\n                            [validationMap]=\"field.validationMap\"\r\n                            (isControlValid)=\"setClassForControlValidity($event)\"></abp-validation-display>\r\n  </div>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpSwitchComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-radio{position:relative;vertical-align:baseline;margin:0;padding:0 0 5px}.abp-radio abp-label,.abp-radio label{cursor:pointer;line-height:1.5;vertical-align:middle;display:inline-block;padding:0 0 1%;margin:0 .5rem .5rem}.abp-radio .option-btn{width:20px;height:20px;display:inline-block;outline-offset:-1px!important}.error{outline:#dc3545 solid 2px}.valid{outline:#28a745 solid 2px}.abp-radio abp-control-label{vertical-align:super;margin-right:.5rem}.abp-switch-button{box-sizing:border-box}.abp-switch-button button{position:relative;display:inline-block;width:75px;height:40px;margin-right:10px;border-radius:20px}.abp-switch-button button:hover{transform:scale(1.2)}.abp-switch-button input{opacity:0;width:0;height:0}.abp-switch-button .active{background-color:#87cefa}.slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;transition:.4s}.slider:before{position:absolute;content:\"\";height:26px;width:26px;left:4px;bottom:4px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#2196f3}input:focus+.slider{box-shadow:0 0 1px #2196f3}input:checked+.slider:before{transform:translateX(26px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [AbpValidationDisplayConstant.validationDisplayConfigInjectKey]
            }] }, { type: ɵngcc0.Injector }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion components
//#region directives
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
//#region services
//#endregion services
//#region handlers/providers
//#endregion handlers/providers
class AbpRadionButtonModule {
    /**
     * @param {?} validationConfig
     * @param {?} labelConfig
     * @return {?}
     */
    static forRoot(validationConfig, labelConfig) {
        return (/** @type {?} */ ({
            ngModule: AbpRadionButtonModule,
            providers: [
                { provide: AbpValidationDisplayConstant.validationDisplayConfigInjectKey, useValue: validationConfig },
                { provide: AbpLabelConstant.labelConfigInjectKey, useValue: labelConfig }
            ]
        }));
    }
}
AbpRadionButtonModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpRadionButtonModule });
AbpRadionButtonModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpRadionButtonModule_Factory(t) { return new (t || AbpRadionButtonModule)(); }, imports: [[
            CommonModule,
            AbpValidationDisplayModule,
            AbpLabelModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpRadionButtonModule, { declarations: function () { return [AbpRadioButtonListComponent, AbpRadioListInlineComponent, AbpSwitchComponent]; }, imports: function () { return [CommonModule,
        AbpValidationDisplayModule,
        AbpLabelModule]; }, exports: function () { return [AbpRadioButtonListComponent, AbpRadioListInlineComponent, AbpSwitchComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpRadionButtonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AbpValidationDisplayModule,
                    AbpLabelModule
                ],
                declarations: [
                    AbpRadioButtonListComponent,
                    AbpRadioListInlineComponent,
                    AbpSwitchComponent
                ],
                exports: [
                    AbpRadioButtonListComponent,
                    AbpRadioListInlineComponent,
                    AbpSwitchComponent
                ],
                entryComponents: [
                    AbpRadioButtonListComponent,
                    AbpRadioListInlineComponent,
                    AbpSwitchComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpRadioButtonListComponent, AbpRadioConstant, AbpRadioListInlineComponent, AbpRadionButtonModule, AbpSwitchComponent };

//# sourceMappingURL=colibrium-abp-radiobutton.js.map